import React, { useState, Fragment, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import RoundedModal from 'components/Core/Modal/RoundedModal/RoundedModal';
import Button from 'components/Shared/Button/Button';
import Hr from 'components/Shared/Hr/Hr';
import Spinner from 'components/Shared/Spinner/Spinner';
import { getTxnTextBasedOnType } from 'shared/utils';
import { colors, fontSize, breakpoints } from 'styles/cp';

export interface Props {
  hide: () => void;
  onCancel: () => void;
  onDecline: () => void;
  isChangeOrder?: boolean;
}

const DeclineEstimateModal: React.FC<Props> = (props: Props) => {
  const [isInProgress, setIsInProgress] = useState(false);
  const { isChangeOrder } = props;
  const { transaction_text } = getTxnTextBasedOnType(isChangeOrder);
  const transaction = (
    <FormattedMessage
      id={transaction_text}
      defaultMessage={transaction_text}
      values={{ transaction: transaction_text }}
    />
  );
  const onCancel = () => {
    props.hide();
    props.onCancel && props.onCancel();
  };

  const onDecline = async (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsInProgress(true);
    await props.onDecline();
    props.hide();
  };

  const header = (
    <FormattedMessage
      id="DECLINE_ESTIMATE_MESSAGE"
      defaultMessage="Decline {transaction} for this business?"
      values={{ transaction }}
    />
  );
  return (
    <Fragment>
      <RoundedModal hide={props.hide} header={header}>
        <div className="decline-estimate-body">
          <div className="decline-message">
            <FormattedMessage
              id="DECLINE_ESTIMATE_MODAL_MESSAGE"
              defaultMessage="We’ll notify them if you decline it, and they’ll reach out to you with next steps."
            />
          </div>
          <Hr marginTop={0} marginBottom={0} borderColor={colors.gray04} />
          <div className="cta">
            <a onClick={onCancel}>
              <FormattedMessage id="DECLINE_ESTIMATE_CANCEL_BUTTON" defaultMessage="Cancel" />
            </a>
            <Button
              buttonType="dark"
              onClick={onDecline}
              aria-label="Decline estimate"
              width={'208px'}
            >
              {isInProgress && (
                <Spinner
                  color={colors.green}
                  label={''}
                  bgStrokeWidth={2.5}
                  width={25}
                  strokeWidth={5}
                  bgColor={colors.gray08}
                />
              )}
              {!isInProgress && (
                <FormattedMessage
                  id="DECLINE_ESTIMATE_BUTTON"
                  defaultMessage="Decline {transaction}"
                  values={{ transaction }}
                />
              )}
            </Button>
          </div>
        </div>
      </RoundedModal>

      <style jsx>{`
        .decline-estimate-body {
          max-width: 496px;
          @media screen and (max-width: ${breakpoints.sm}) {
            max-width: 320px;
          }

          .decline-message {
            padding: 16px 0;
            text-align: left;
          }
        }
        a {
          line-height: 36px;
          font-size: ${fontSize.xs};
          color: ${colors.intuit_blue};
          cursor: pointer;
          @media screen and (max-width: ${breakpoints.sm}) {
            margin-top: 28px;
            line-height: 16px;
          }
        }

        .cta {
          margin-top: 72px;
          display: flex;
          justify-content: space-between;
          @media screen and (max-width: ${breakpoints.sm}) {
            margin-top: 48px;
            flex-direction: column-reverse;
            align-items: center;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default DeclineEstimateModal;
